export enum CustomApiExceptionType {
  AI_EXTRACTION_ALREADY_STARTED_EXCEPTION = 'AiExtractionAlreadyStartedException',
  DOMAIN_SSO_EXISTS_EXCEPTION = 'DomainSsoExistsException',
  INVALID_COMPANY_DOMAIN_EXCEPTION = 'InvalidCompanyDomainException',
  SSO_NOT_CONFIGURED_EXCEPTION = 'SsoNotConfiguredException'
}
